const Portfolio = () => {
  return (
    <section className='py-40 px-8'>
      <div className='max-w-7xl mx-auto'>
        <h2 className='text-5xl font-semibold mb-20'>Selected work</h2>

        <div className='grid md:grid-cols-2 gap-10'>
          <div className='h-[420px] bg-neutral-900 rounded-2xl p-10 flex items-end hover:bg-neutral-800 transition'>
            <h3 className='text-3xl'>Startup Landing Page</h3>
          </div>

          <div className='h-[420px] bg-neutral-900 rounded-2xl p-10 flex items-end hover:bg-neutral-800 transition'>
            <h3 className='text-3xl'>Brand Identity</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
